import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { TopupStatus, TopupType } from '@/models/features/communication'
import { resetQueries } from '@/utils'

type GetGiftCardTopupsRequest = {
  buildingId?: number
  limit: number
  skip: number
  from?: number
  to?: number
  search?: string
}

export type GiftCardTopupRecord = {
  id: number
  type: TopupType
  amount: number
  status: TopupStatus
  buildingName: string
  buildingId: number
  userFullName: string
  byUserEmail: string
  byRoleName: string
  createdAt: number
  stripeId: string | null
  changedBy: string | null
  balanceBefore: number
  balanceAfter: number
  convenienceFee: number | null
}

type GetGiftCardTopupsResponse = {
  total: number
  data: GiftCardTopupRecord[]
}

const GET_GIFT_CARD_TOPUPS_QUERY_KEY = 'useGetGiftCardTopups'

export const getGiftCardTopupsQueryKey = (data: GetGiftCardTopupsRequest) => [
  GET_GIFT_CARD_TOPUPS_QUERY_KEY,
  data,
]

export const getGiftCardTopups = async (data: GetGiftCardTopupsRequest, signal?: AbortSignal) => {
  const response = await authAPI.get<GetGiftCardTopupsResponse>('/reward/topup/history', {
    params: data,
    signal,
  })
  return response.data
}

export const useGetGiftCardTopups = (data: GetGiftCardTopupsRequest) => {
  return useQuery({
    placeholderData: keepPreviousData,
    queryFn: ({ signal }) => getGiftCardTopups(data, signal),
    queryKey: getGiftCardTopupsQueryKey(data),
  })
}

export const useInvalidateGiftCardTopups = () => {
  return () => resetQueries([GET_GIFT_CARD_TOPUPS_QUERY_KEY])
}
